export enum PaymentMethods {
  Cash = 0,
  Card = 1,
  Employee = 2,
}
